import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoltCircleLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.16637 6.16637C9.38819 2.94454 14.6118 2.94454 17.8336 6.16637C21.0555 9.38819 21.0555 14.6118 17.8336 17.8337C14.6118 21.0555 9.38819 21.0555 6.16637 17.8337C2.94454 14.6118 2.94454 9.38819 6.16637 6.16637ZM18.8943 5.10571C15.0867 1.2981 8.91332 1.2981 5.10571 5.10571C1.2981 8.91332 1.2981 15.0867 5.10571 18.8943C8.91332 22.7019 15.0867 22.7019 18.8943 18.8943C22.7019 15.0867 22.7019 8.91332 18.8943 5.10571ZM12.644 8.40688C12.8688 8.05894 12.7689 7.59469 12.4209 7.36995C12.073 7.14522 11.6087 7.2451 11.384 7.59305L8.79967 11.5942C8.65066 11.8249 8.63967 12.1186 8.77102 12.3598C8.90236 12.601 9.15504 12.7511 9.42969 12.7511H13.1941L11.3559 15.5926C11.1309 15.9404 11.2305 16.4047 11.5782 16.6297C11.926 16.8547 12.3903 16.7551 12.6153 16.4074L15.2023 12.4085C15.3515 12.1778 15.3627 11.884 15.2314 11.6427C15.1001 11.4013 14.8473 11.2511 14.5726 11.2511H10.807L12.644 8.40688Z",
		fill: "currentColor"
	})
});
export default SvgBoltCircleLine;
